import { render, staticRenderFns } from "./AddEmployerUserForm.vue?vue&type=template&id=206c58b2&scoped=true"
import script from "./AddEmployerUserForm.vue?vue&type=script&lang=ts"
export * from "./AddEmployerUserForm.vue?vue&type=script&lang=ts"
import style0 from "./AddEmployerUserForm.vue?vue&type=style&index=0&id=206c58b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c58b2",
  null
  
)

export default component.exports